import React, { FC, ReactNode } from 'react';
import cx from 'clsx';

import { TOTALS_SHIMMER_TEST_ID } from './const';

import styles from './styles.module.scss';

const TOTAL_INVOICE_LINES = 1;
const TOTAL_CHECKOUT_LINES = 3;

type TotalsShimmerProps = {
  isInvoiceMode?: boolean;
};

const TotalsShimmer: FC<TotalsShimmerProps> = ({ isInvoiceMode }) => {
  const items: ReactNode[] = [];
  const totalLines = isInvoiceMode ? TOTAL_INVOICE_LINES : TOTAL_CHECKOUT_LINES;

  for (let i = 0; i < totalLines; i++) {
    // eslint-disable-next-line
    items.push(
      <p key={i}>
        <span className={cx('shimmer', styles.total)} />
        <span className={cx('shimmer', styles.amount)} />
      </p>
    );
  }

  return (
    <div className={styles.container} data-testid={TOTALS_SHIMMER_TEST_ID}>
      {items}
    </div>
  );
};

export { TotalsShimmer };
